import * as React from 'react';

import {
  Select
} from 'antd';

import {
  SelectProps
} from 'antd/lib/select';
import { localizedString } from '@locale/index';
import './index.less';
import { defaultSelectListHeight } from '@config/styledVar';

export type NiSelectProp = SelectProps<string>;

export interface NiSelectStateInfo { }

export class NiSelect extends React.Component<NiSelectProp,
  NiSelectStateInfo> {
  static Option = Select.Option;
  static OptGroup = Select.OptGroup;
  dom: any = React.createRef();

  render() {

    const props: SelectProps<string> = {
      // suffixIcon: <CaretDownOutlined />,
      dropdownMatchSelectWidth: false,
      placeholder: localizedString('common_select'),
      listHeight: defaultSelectListHeight,
      showSearch: true,
      // size: 'large',
      ...this.props,
      className: 'ni-select ' + this.props.className
    };

    // antd 4.0的问题，value为undefine的时，placeholder会自动替换成选择值，我们需要选择后不影响placeholder的场景
    if (props.value === undefined) {
      // tslint:disable-next-line: no-null-keyword
      props.value = null as any;
    }

    return <Select {
      ...props
    } />;
  }
}
